export default __webpack_public_path__ + "static/media/dessous_de_verre.431463b5.jpg";